// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"85":"ccbdfff0","152":"c66c2546","252":"8c75be60","636":"8dcf4864","911":"52133047","949":"bd390d4b","977":"fd3ec77a"}[chunkId] + ".css";
};